export default __webpack_public_path__ + "static/media/Token.a7a3c43b.svg";